// extracted by mini-css-extract-plugin
var _1 = "ContentMapColumnHeader-module__animateUploadProgressBarWidth--GOqe7";
var _2 = "ContentMapColumnHeader-module__animatedBackground--oK2En";
var _3 = "ContentMapColumnHeader-module__badgeContainer--AcSJh";
var _4 = "ContentMapColumnHeader-module__container--ADR2w";
var _5 = "ContentMapColumnHeader-module__name--MFLfA";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "badgeContainer", _4 as "container", _5 as "name" }
